module.exports = __webpack_public_path__ + "img/hotel-15.eb5626a9.jpeg";